import React from 'react';

interface QuestionHeaderProps {
  questionNumber: number;
  questionText: string;
  scoreText: string;
  scoreColorClass: string;
}

const QuestionHeader: React.FC<QuestionHeaderProps> = ({
  questionNumber,
  questionText,
  scoreText,
  scoreColorClass
}) => {
  return (
    <div className="card-header">
      <div className="question-info">
        <span className="question-number">{questionNumber}.</span>
        <span className="question-text">{questionText}</span>
      </div>
      <div className={`score-badge ${scoreColorClass}`}>
        {scoreText}
      </div>
    </div>
  );
};

export default QuestionHeader;

